export * from "ce/middlewares/RouteParamsMiddleware";
import { default as EE_RouteParamsMiddleware } from "ce/middlewares/RouteParamsMiddleware";
export default EE_RouteParamsMiddleware;
